/**
 * Nav Bar when viewing events details
 */
import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import '../../style/nav.css';
import "../../style/creationstyle.css";
import {useHistory} from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
//displays nav Bar when viewing event details
function NavBarEvent() {
    const [userName, setUserName] = useState("");
    const history = useHistory();
    const loggedInUser = getCookie("link2rsvp");

    useEffect(() => {
        getName();
    });

    //Cookie
    /**
     * deleteCookie()
     * when log out is selected, cookie is set to expire at current time
     */
    function deleteCookie() {
        document.cookie = "link2rsvp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    /**
     * getCookie()
     * getting the user cookie to display their name
     */
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return null;
      }
    //end of Cookie
    //function logout(), deletes user cookies
    async function logout() {
        await axios.get("https://link2rsvp.herokuapp.com/auth/logout");
        deleteCookie();

        history.push("/");
    }

    async function getName() {
        const loggedUser = {
            email: loggedInUser
        }
        
        const user = await axios.post("https://link2rsvp.herokuapp.com/auth/loggedin", loggedUser);
        
        setUserName(user.data);
    }

    return (
        <div id="head">
                <h1 id="headp">LINK2RSVP</h1>
                <Button id="back-btn" variant="light" onClick={() => history.push("/home")}>&#8592; Home</Button>
                <Dropdown id="logout-btn">
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                        {userName}
                    </Dropdown.Toggle>
                    
                    <Dropdown.Menu>
                    <Dropdown.Item href="/home">Home</Dropdown.Item>
                    <Dropdown.Item href="/contactloggedin">Contact LINK2RSVP</Dropdown.Item>
                    <Dropdown.Item onClick={logout} id="logout">Logout</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div> 
    );
}

export default NavBarEvent;